export const ErrorConstants = {
  VerifyAbnError: {
    title: 'We are unable to verify your ABN.',
    description: 'We cannot verify your ABN at this moment. Please try after sometime',
  },
  VerifyAccountError: {
    title: 'We are unable to verify your account.',
    description: 'We cannot verify your account at this moment. Please try after sometime',
  },
  VerifyBsbError: {
    title: 'We are unable to verify your bank state branch.',
    description: 'We cannot verify your bank state branch at this moment. Please try after sometime',
  },
  VerifyExternalEmailError: {
    title: 'Email verification failed!',
    description: 'We cannot verify your email at this moment. Please try after sometime',
  },
};

export const ApiErrorConstants = {
  REFRESH_TOKEN_ERROR: 'RefreshAccessTokenError',
  SESSION_EXPIRED_MESSAGE: 'Your session has expired. Please login again.',
  KYC_FAILED_MESSAGE: 'KYC failed!',
  INVOICE_ERROR: 'Invoice not found!',
  APPROVE_PAYMENT_ERROR: 'Approval failed!',
  EIN_FAILED: 'EIN verification failed!',
};
